 
 
 
 
 
 
define(['http', 'security', './utils', 'endpoints'], function(http, security, utils, endpoints) {
    'use strict';

    var queryParamNames = ['language', 'expandCluster', 'geometries', 'originalPosition'];

    return {
        incidentsDetails: function(options, callback) {
            var pathParams = {};
            var queryParams = {
                projection: 'EPSG4326'
            };

            // default the trafficModelID to -1
            pathParams.trafficModelID = utils.or(options.trafficModelID, -1);

            pathParams.zoom = utils.required(options.zoomLevel, 'Missing zoomLevel required parameter');

            //traffic service supports only integers
            pathParams.zoom = Math.round(pathParams.zoom);

            pathParams.minLon = utils.required(options.minLon, 'Missing minLon required parameter');
            pathParams.minLat = utils.required(options.minLat, 'Missing minLat required parameter');
            pathParams.maxLon = utils.required(options.maxLon, 'Missing maxLon required parameter');
            pathParams.maxLat = utils.required(options.maxLat, 'Missing maxLat required parameter');

            pathParams.style = utils.or(options.style, 'night');

            // if an API key is specified, include it
            // an API key can be omitted if an API proxy is being used
            queryParams.key = utils.or(options.key, security.getKey('services/traffic'));

            utils.extractQueryParams(options, queryParams, queryParamNames);

            http.get({
                url: '{protocol}://' + endpoints.trafficIncidents,
                pathParameters: pathParams,
                queryParameters: queryParams,
                callback: callback,
                fail: options.fail
            });
        }
    };
});



// WEBPACK FOOTER //
// ./rest/trafficIncidents.js